<template>
  <div class="workOrderList workOrderList--a">
    <loading v-if="loading"></loading>
    <div class="workOrderList__title">工单列表</div>
    <div class="workOrderList__list">
      <div
        v-for="(item, index) in list"
        :key="index"
        class="workOrderList__list__item"
        @click="pushDetails(item.id)"
      >
        <div class="workOrderList__list__item__header">
          <div>工单编号：{{ item.field4 }}</div>
          <div :style="{ color: item.field45 != '订单关闭' ? '#4C7BFF' : '' }">
            {{ item.field45 }}
          </div>
        </div>
        <div class="workOrderList__list__item__main">
          <div class="workOrderList__list__item__main__item">
            <div class="workOrderList__list__item__main__item__name">
              工单名称
            </div>
            <div style="color: #26252a">{{ item.Name }}</div>
          </div>
          <div class="workOrderList__list__item__main__item">
            <div class="workOrderList__list__item__main__item__name">
              下单时间
            </div>
            <div style="color: #26252a">{{ item.createdTimeStr }}</div>
          </div>
        </div>
        <div
          style="display: flex; justify-content: flex-end; margin-bottom: 8px"
        >
          <div style="width: 100px"></div>
          <div
            style="
              width: calc(100% - 100px);
              height: 0.5px;
              border: 0.5px dashed #d9d9d9;
            "
          ></div>
        </div>
        <div class="workOrderList__list__item__foot">
          <div class="workOrderList__list__item__foot__item">
            <div
              class="workOrderList__list__item__foot__item__but"
              @click.stop="showSheet = true"
            >
              联系售后服务人员
            </div>
            <div
              class="workOrderList__list__item__foot__item__but"
              v-if="item.field45 === '待邮寄'"
              @click.stop="pushExpress(item.id)"
            >
              填写单号
            </div>
            <div
              class="workOrderList__list__item__foot__item__but"
              v-if="item.field45 === '维修报价'"
              @click.stop="verifyOrder(item.id)"
            >
              确认报价
            </div>
            <div
              class="workOrderList__list__item__foot__item__but"
              v-if="item.field45 === '已发货'"
              @click.stop="verifyReceive(item.id)"
            >
              确认收货
            </div>
            <div
              class="workOrderList__list__item__foot__item__but"
              v-if="item.field45 === '待受理' || item.field45 === '待邮寄'"
              @click.stop="verifyCancel(item.id)"
            >
              取消订单
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="list.length === 0" class="workOrderList__img">
      <div style="margin-top: 160px">
        <img
          style="width: 150px; height: 150px"
          src="@/assets/img/official-account/nolist.png"
          alt=""
        />
        <div style="font-size: 13px; color: #adadad; margin-top: 16px">
          暂无工单
        </div>
      </div>
    </div>
    <van-dialog
      v-model="dialogShow"
      :title="dialogSty.title"
      @confirm="dialogConfirm"
      show-cancel-button
      confirm-button-color="#82BF25"
    >
      <div style="margin: 10px 0 20px 16px; color: #888888; font-size: 12px">
        {{ dialogSty.content }}
      </div>
    </van-dialog>
    <ActionSheet
      v-model="showSheet"
      :actions="sheetList"
      @select="sheetConfirm"
      cancel-text="取消"
      close-on-click-action
    />
  </div>
</template>

<script>
import { initOpenid } from "@/utils/getOpenid";
import {
  getList,
  cancel,
  confirmReceipt,
  confirmRepair,
} from "@/api/officialAccount/index.js";
import { Dialog, ActionSheet } from "vant";

export default {
  components: {
    ActionSheet,
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      list: [],
      openId: null,
      dialogShow: false,
      cancelId: 0,
      loading: true,
      dialogSty: {
        title: "",
        content: "",
        id: "",
      },
      showSheet: false,
      sheetList: [{ name: "0769-81504599" }],
    };
  },
  created() {
    if (!localStorage.getItem("openId")) {
      initOpenid(this.getListHanlde);
    } else {
      this.getListHanlde();
    }
  },
  mounted() {},
  methods: {
    // 列表
    async getListHanlde() {
      this.openId = localStorage.getItem("openId");
      const { data, code } = await getList({
        openid: this.openId,
      });
      if (code !== "0000000") {
        this.loading = false;
        return;
      }
      this.loading = false;
      this.list = data;
    },
    // 取消订单
    async cancelHanlde() {
      const { code } = await cancel({
        id: this.dialogSty.id,
        openid: this.openId,
      });
      if (code !== "0000000") {
        return;
      }
      this.getListHanlde();
    },
    // 确认报价
    async confirmRepairHanlde() {
      const { code } = await confirmRepair({
        agree: 1,
        id: this.dialogSty.id,
        openid: this.openId,
      });
      if (code !== "0000000") {
        return;
      }
      this.getListHanlde();
    },
    // 确认收货
    async confirmReceiptHanlde() {
      const { code } = await confirmReceipt({
        id: this.dialogSty.id,
        openid: this.openId,
      });
      if (code !== "0000000") {
        return;
      }
      this.getListHanlde();
    },
    // 取消订单弹窗
    verifyCancel(id) {
      this.dialogShow = true;
      this.dialogSty.title = "取消工单";
      this.dialogSty.content = "您确定要取消该工单吗？";
      this.dialogSty.id = id;
    },
    // 确认报价
    verifyOrder(id) {
      console.log(id);
      this.dialogShow = true;
      this.dialogSty.title = "是否同意该报价";
      this.dialogSty.content = "点击确定后即可与商务洽谈维修合同细则。";
      this.dialogSty.id = id;
    },
    // 确认收货
    verifyReceive(id) {
      this.dialogShow = true;
      this.dialogSty.title = "是否确认收货";
      this.dialogSty.content = "收货前请仔细检查产品，确保没有损坏或缺陷。";
      this.dialogSty.id = id;
    },
    // 弹窗确认
    dialogConfirm() {
      if (this.dialogSty.title === "取消工单") {
        this.cancelHanlde();
      } else if (this.dialogSty.title === "确认报价") {
        this.confirmRepairHanlde();
      } else if (this.dialogSty.title === "确认收货") {
        this.confirmReceiptHanlde();
      }
    },
    // 拨打电话
    sheetConfirm() {
      window.location.href = "tel:076981504599";
    },
    // 填写单号
    pushExpress(id) {
      this.$router.push({ path: "/expressDelivery", query: { id: id } });
    },
    // 查看详情
    pushDetails(id) {
      console.log(id);
      this.$router.push({ path: "/workOrderDetails", query: { id: id } });
    },
  },
};
</script>

<style lang="less" scoped>
::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}
.workOrderList {
  width: 100%;
  // height: 100%;
  color: #000;
  height: 100vh;
  overflow-y: auto;
  &__img {
    width: 100%;
    height: calc(100vh - 3rem);
    display: flex;
    text-align: center;
    justify-content: center;
  }
  &__list {
    &__item {
      margin-top: 16px;
      background-color: #fff;
      &__foot {
        padding-left: 12px;
        &__item {
          width: 100%;
          height: 54px;
          font-size: 14px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          &__but {
            color: #676767;
            width: 77px;
            font-size: 12px;
            border: 1px solid #efefef;
            border-radius: 40px;
            height: 29.5px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right: 12px;
          }
        }
      }
      &__main {
        padding: 0 12px;
        font-size: 12px;
        &__item {
          height: 36px;
          display: flex;
          align-items: center;
          &__name {
            margin-right: 40px;
            color: #979797;
            min-width: 48px;
          }
        }
      }
      &__header {
        display: flex;
        font-size: 12px;
        color: #979797;
        justify-content: space-between;
        padding: 0 12px;
        height: 44px;
        align-items: center;
      }
    }
  }
  &__title {
    height: 3rem;
    line-height: 3rem;
    font-size: 20px;
    font-weight: 900;
    background: #ffffff;
    padding-left: 12px;
  }
}
</style>

<!--
  改版方案 A（2026-09-22）：分组列表。只改样式和布局，文字不动。
  回退：去掉模板根节点上的 workOrderList--a。
-->
<style lang="less" scoped>
@a-bg: #f2f2f7;
@a-card: #fff;
@a-line: #e9e9ee;
@a-ink: #1c1c1e;
@a-sub: #8a8a8e;
@a-green-text: #3f9a2e;
@a-radius: 12px;

.workOrderList--a {
  background: @a-bg;
  color: @a-ink;
  padding-bottom: calc(24px + env(safe-area-inset-bottom, 0px));

  .workOrderList__title {
    height: auto;
    line-height: 1.2;
    padding: 18px 20px 4px;
    background: transparent;
    font-size: 28px;
    font-weight: 700;
  }

  // 一张工单一张卡片
  .workOrderList__list__item {
    margin: 14px 16px 0;
    background: @a-card;
    border-radius: @a-radius;
    overflow: hidden;
  }
  .workOrderList__list__item__header {
    height: auto;
    padding: 12px 16px;
    font-size: 13px;
    color: @a-sub;

    // 状态：进行中的（模板里带了颜色）用品牌绿，已关闭的灰色
    & > div:last-child {
      flex: none;
      font-size: 13px;
      font-weight: 600;
      color: @a-sub;
    }
    & > div[style*="color"] {
      color: @a-green-text !important;
    }
  }
  .workOrderList__list__item__main {
    padding: 0;
    font-size: 15px;
  }
  .workOrderList__list__item__main__item {
    position: relative;
    height: auto;
    min-height: 44px;
    padding: 10px 16px;

    &::before {
      content: "";
      position: absolute;
      left: 16px;
      right: 0;
      top: 0;
      border-top: 1px solid @a-line;
    }
    &__name {
      min-width: 64px;
      margin-right: 16px;
      color: @a-sub;
    }
    & > div:last-child {
      flex: 1;
      text-align: right;
      color: @a-ink !important;
    }
  }
  // 原来的虚线分隔，由上面的细线代替
  .workOrderList__list__item__main + div {
    display: none !important;
  }

  // 操作按钮
  .workOrderList__list__item__foot {
    padding: 0 16px;
    border-top: 1px solid @a-line;
  }
  .workOrderList__list__item__foot__item {
    height: auto;
    padding: 10px 0;
    gap: 8px;
    flex-wrap: wrap;
  }
  .workOrderList__list__item__foot__item__but {
    width: auto;
    height: 30px;
    margin: 0;
    padding: 0 12px;
    border: none;
    border-radius: 15px;
    background: @a-bg;
    color: @a-ink;
    font-size: 13px;

    &:first-child {
      color: @a-green-text;
    }
  }
}
</style>
